"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreatorAlignTarget = void 0;
var _react = _interopRequireDefault(require("react"));
var _Containers = require("../Creator/Containers");
var _styles = require("@material-ui/core/styles");
var _reactRedux = require("react-redux");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  var _withDesignViews, _root;
  return {
    root: (_root = {
      marginTop: 36
    }, _defineProperty(_root, theme.breakpoints.down('xs'), {
      maxHeight: 'calc(100% - 270px)'
    }), _defineProperty(_root, theme.breakpoints.up('sm'), _defineProperty({
      maxHeight: 'calc(100% - 58px)'
    }, theme.orientation.portrait, {
      maxHeight: 'calc(100% - 260px)'
    })), _defineProperty(_root, theme.breakpoints.up(theme.creator.viewSelectBreakpoint), {
      marginTop: 0
    }), _defineProperty(_root, theme.breakpoints.between(theme.creator.viewSelectBreakpoint, 'lg'), {
      maxHeight: 'calc(100% - 152px)'
    }), _defineProperty(_root, theme.breakpoints.up('lg'), {
      maxHeight: 'calc(100% - 154px)'
    }), _defineProperty(_root, '@media (min-aspect-ratio: 13/9) and (min-height: 280px) and (max-width: 950px)', {
      maxHeight: '100%'
    }), _defineProperty(_root, '&.withDesignViews', (_withDesignViews = {}, _defineProperty(_withDesignViews, theme.breakpoints.up('sm'), _defineProperty({
      maxHeight: 'calc(100% - 136px)'
    }, theme.orientation.portrait, {
      maxHeight: 'calc(100% - 260px)'
    })), _defineProperty(_withDesignViews, theme.breakpoints.between(theme.creator.viewSelectBreakpoint, 'lg'), {
      maxHeight: 'calc(100% - 156px)'
    }), _defineProperty(_withDesignViews, theme.breakpoints.up('lg'), {
      maxHeight: 'calc(100% - 196px)'
    }), _withDesignViews)), _root)
  };
};
var StyledAlignTargetContainer = (0, _styles.withStyles)(styles, {
  name: 'CreatorAlignTarget'
})(_Containers.AlignTargetContainer);
var CreatorAlignTarget = exports.CreatorAlignTarget = function CreatorAlignTarget(props) {
  var className = (0, _reactRedux.useSelector)(function (state) {
    var _state$designView;
    return ((_state$designView = state.designView) === null || _state$designView === void 0 ? void 0 : _state$designView.designViews.length) > 1;
  }) && 'withDesignViews';
  return /*#__PURE__*/_react["default"].createElement(StyledAlignTargetContainer, _extends({
    className: className
  }, props));
};